//  Order Types
export const ORDER_TYPES = Object.freeze({
  DINE_IN: "DINE_IN",
  DELIVERY: "DELIVERY",
  TAKEAWAY: "TAKEAWAY",
  COUNTER: "COUNTER",
});

export const ORDER_TYPE_LABELS = Object.freeze({
  [ORDER_TYPES.DINE_IN]: "Dine In",
  [ORDER_TYPES.TAKEAWAY]: "Take Away",
  [ORDER_TYPES.DELIVERY]: "Delivery",
  [ORDER_TYPES.COUNTER]: "Counter",
});

// Payment Methods
export const PAYMENT_METHODS = Object.freeze({
  CASH: {
    value: 1,
    label: "Cash",
    icon: "mdi:cash",
  },
  UPI: {
    value: 2,
    label: "UPI",
    icon: "material-symbols:qr-code",
  },
  CARD: {
    value: 3,
    label: "Card",
    icon: "ic:baseline-credit-card",
  },
  // CHEQUE: {
  //   value: 4,
  //   label: "Cheque",
  //   icon: "iconamoon:cheque",
  // },
  OTHER: {
    value: 5,
    label: "Other",
    icon: "material-symbols:other-admission-outline",
  },
  PART: {
    value: 6,
    label: "Part",
    icon: "streamline:money-cash-bill-3-accounting-billing-payment-finance-cash-currency-money-bill",
  },
});

// Currency Options
export const CURRENCIES = Object.freeze({
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
});

export const CURRENCY_LABELS = Object.freeze({
  [CURRENCIES.INR]: "INR (₹)",
  [CURRENCIES.USD]: "USD ($)",
  [CURRENCIES.EUR]: "EUR (€)",
  [CURRENCIES.GBP]: "GBP (£)",
});

// Date & Time Formats
export const DATE_TIME_FORMATS = Object.freeze({
  TWELVE_HOUR: "12hr",
  TWENTY_FOUR_HOUR: "24hr",
});

export const DATE_TIME_FORMAT_LABELS = Object.freeze({
  [DATE_TIME_FORMATS.TWELVE_HOUR]: "12 Hour",
  [DATE_TIME_FORMATS.TWENTY_FOUR_HOUR]: "24 Hour",
});

// Language Options
export const LANGUAGES = Object.freeze({
  ENGLISH: "en",
  HINDI: "hi",
  SPANISH: "es",
});

export const LANGUAGE_LABELS = Object.freeze({
  [LANGUAGES.ENGLISH]: "English",
  [LANGUAGES.HINDI]: "Hindi",
  [LANGUAGES.SPANISH]: "Spanish",
});

// Timezones
export const TIMEZONES = Object.freeze({
  IST: "Asia/Kolkata",
  UTC: "UTC",
  EST: "America/New_York",
  GMT: "Europe/London",
  GST: "Asia/Dubai",
});

export const TIMEZONE_LABELS = Object.freeze({
  [TIMEZONES.IST]: "Asia/Kolkata (IST)",
  [TIMEZONES.UTC]: "UTC",
  [TIMEZONES.EST]: "America/New_York (EST)",
  [TIMEZONES.GMT]: "Europe/London (GMT)",
  [TIMEZONES.GST]: "Asia/Dubai (GST)",
});

export const ITEM_TYPE_COLORS = {
  Veg: "green", // Veg
  "Non-veg": "red", // Non-Veg
  Egg: "orange", // Egg
};

export const ORDER_TYPE_CODES = {
  DINE_IN: 1,
  DELIVERY: 2,
  TAKEAWAY: 3,
  COUNTER: 5,
};

export const PAYMENT_STATUS_CODES = {
  PAID: 1,
  UNPAID: 2,
  PARTIAL: 3,
  REFUND: 4,
};

export const ORDER_TYPES_VALUES = [
  {
    label: "Dine In",
    icon: "clarity:store-solid",
    bgColor: "#ffa726",
    value: ORDER_TYPE_CODES.DINE_IN,
  },
  {
    label: "Counter",
    icon: "mdi:cash-register",
    bgColor: "#ab47bc",
    value: ORDER_TYPE_CODES.COUNTER,
  },
  {
    label: "Delivery",
    icon: "fa-solid:truck",
    bgColor: "#66bb6a",
    value: ORDER_TYPE_CODES.DELIVERY,
  },
  {
    label: "Take Away",
    icon: "fluent:person-walking-20-filled",
    bgColor: "#29b6f6",
    value: ORDER_TYPE_CODES.TAKEAWAY,
  },
];

export const ORDER_TABLE_STATUS = {
  // 0: Neutral / Available
  FREE: {
    id: 0,
    label: "Free Table",
    //color: "#EBF4FF",
    color: "#E2E8F0",
  },

  // 1: Customer Present, No Order
  OCCUPIED: {
    id: 1,
    label: "Occupied",
    color: "#90CDF4",
  },

  // 2: Order in Kitchen
  KOT_SENT: {
    id: 2,
    label: "KOT Sent",
    color: "#48BB78",
  },

  // 3: Waiter Action Required
  BILL_REQUESTED: {
    id: 3,
    label: "Bill Requested",
    color: "#F6AD55",
  },

  // 4: Payment in Progress
  SETTLEMENT: {
    id: 4,
    label: "Settlement in Progress",
    color: "#B794F4",
  },

  // // 5: Unusable - Scheduled
  // RESERVED: {
  //   id: 5,
  //   label: "Reserved",
  //   color: "#2D3748",
  // },

  // // 6: Unusable - Maintenance
  // DIRTY: {
  //   id: 6,
  //   label: "Dirty / Cleaning",
  //   color: "#A0AEC0",
  // },
};

export const KOT_STATUS = {
  INPROGRESS: 1,
  READY: 2,
  CANCELLED: 3,
};

export const ORDER_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  IN_PROGRESS: 3,
  READY: 4,
  COMPLETED: 5,
  ON_HOLD: 6,
  CANCELLED: 7,
  REJECTED: 8,
};

export const ORDER_STATUS_VALUES = [
  {
    value: ORDER_STATUS.PENDING,
    label: "Pending",
    color: "#9e9e9e", // Grey – waiting
  },
  {
    value: ORDER_STATUS.ACCEPTED,
    label: "Accepted",
    color: "#0288d1", // Blue – acknowledged
  },
  {
    value: ORDER_STATUS.IN_PROGRESS,
    label: "In Progress",
    color: "#ed6c02", // Orange – being prepared
  },
  {
    value: ORDER_STATUS.READY,
    label: "Ready",
    color: "#7b1fa2", // Purple – ready to serve / pickup
  },
  {
    value: ORDER_STATUS.COMPLETED,
    label: "Completed",
    color: "#2e7d32", // Green – done
  },
  {
    value: ORDER_STATUS.ON_HOLD,
    label: "On Hold",
    color: "#f9a825", // Amber – attention needed
  },
  {
    value: ORDER_STATUS.CANCELLED,
    label: "Cancelled",
    color: "#d32f2f", // Red – cancelled
  },
  {
    value: ORDER_STATUS.REJECTED,
    label: "Rejected",
    color: "#b71c1c", // Dark Red – rejected (stronger than cancelled)
  },
];

export const ORDER_TABS_CONFIG = [
  {
    value: "",
    label: "All",
    color: "#9e9e9e", // Grey
  },
  {
    value: ORDER_STATUS.IN_PROGRESS,
    label: "In Process",
    color: "#ed6c02", // Orange
  },
  {
    value: ORDER_STATUS.READY,
    label: "Ready",
    color: "#7b1fa2", // Purple
  },
  {
    value: ORDER_STATUS.COMPLETED,
    label: "Completed",
    color: "#2e7d32", // Green
  },
  {
    value: ORDER_STATUS.ON_HOLD,
    label: "On Hold",
    color: "#0288d1", // Blue
  },
  {
    value: ORDER_STATUS.CANCELLED,
    label: "Cancelled",
    color: "#d32f2f", // Red
  },
];

export const ORDER_PAYMENT = [
  {
    value: PAYMENT_STATUS_CODES.PAID,
    label: "Paid",
  },
  {
    value: PAYMENT_STATUS_CODES.UNPAID,
    label: "Unpaid",
  },
  // {
  //   value: PAYMENT_STATUS_CODES.PARTIAL,
  //   label: "Partial",
  // },
  // {
  //   value: PAYMENT_STATUS_CODES.REFUND,
  //   label: "Refund",
  // },
];

export const ORDER_TYPE_CHANGE_SCENARIOS = {
  DINEIN_TO_COUNTER: {
    getMessage: ({ tableName }) => (
      <>
        Your current table {tableName && <strong>{tableName}</strong>} will be
        reset to Free.
      </>
    ),
    requireTableSelection: false,
  },
  DINEIN_TO_DELIVERY: {
    getMessage: ({ tableName }) => (
      <>
        Your current table {tableName && <strong>{tableName}</strong>} will be
        reset to Free. The order will be set as Delivery.
      </>
    ),
    requireTableSelection: false,
  },
  DINEIN_TO_TAKEAWAY: {
    getMessage: ({ tableName }) => (
      <>
        Your current table {tableName && <strong>{tableName}</strong>} will be
        reset to Free. The order will be set as Take Away.
      </>
    ),
    requireTableSelection: false,
  },
  COUNTER_TO_DINEIN: {
    getMessage: () =>
      `Please select an available table to assign and convert this order to Dine In`,
    requireTableSelection: true,
  },
  COUNTER_TO_DELIVERY: {
    getMessage: () => (
      <>
        The order will be set as Delivery. If the address is not added, click on{" "}
        <strong>Add Customer</strong> to enter delivery details.
      </>
    ),
    requireTableSelection: false,
  },
  COUNTER_TO_TAKEAWAY: {
    getMessage: () => `The order will be set as Take Away.`,
    requireTableSelection: false,
  },
  DELIVERY_TO_DINEIN: {
    getMessage: () =>
      `Please select an available table to assign and convert this order to Dine In.`,
    requireTableSelection: true,
  },
  DELIVERY_TO_COUNTER: {
    getMessage: () => `The order will be set as Counter.`,
    requireTableSelection: false,
  },
  DELIVERY_TO_TAKEAWAY: {
    getMessage: () => `The order will be set as Take Away.`,
    requireTableSelection: false,
  },
  TAKEAWAY_TO_DINEIN: {
    getMessage: () =>
      `Please select an available table to assign and convert this order to Dine In.`,
    requireTableSelection: true,
  },
  TAKEAWAY_TO_COUNTER: {
    getMessage: () => `The order will be set as Counter.`,
    requireTableSelection: false,
  },
  TAKEAWAY_TO_DELIVERY: {
    getMessage: () => (
      <>
        The order will be set as Delivery. If the address is not added, click on{" "}
        <strong>Add Customer</strong> to enter delivery details.
      </>
    ),
    requireTableSelection: false,
  },
};

/**
 * returns the label for a given order type value
 */

export function getPaymentMethod(value) {
  return (
    Object.values(PAYMENT_METHODS).find((method) => method.value === value) ||
    null
  );
}

export function getOrderTypeLabel(value) {
  if (value === null || value === undefined) return "";
  const found = ORDER_TYPES_VALUES.find((type) => type.value === value);
  return found ? found.label : undefined;
}

export function getOrderType(value) {
  if (value === null || value === undefined) return null;
  const found = ORDER_TYPES_VALUES.find((type) => type.value === value);
  return found || null;
}

export const orderTableStatusById = Object.values(ORDER_TABLE_STATUS).reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {},
);

export const getOrderTableStatus = (id) => {
  return orderTableStatusById[id] || null;
};

export function getOrderTypeChangeScenario(
  currentOrderType,
  orderType,
  options = {},
) {
  const ORDER_TYPE_LABELS = ORDER_TYPES_VALUES.reduce((acc, cur) => {
    acc[cur.value] = cur.label.toUpperCase().replace(/\s+/g, "");
    return acc;
  }, {});

  const fromLabel = ORDER_TYPE_LABELS[orderType.type];
  const toLabel = ORDER_TYPE_LABELS[currentOrderType.type];

  const key = `${fromLabel}_TO_${toLabel}`;
  const scenario = ORDER_TYPE_CHANGE_SCENARIOS[key] || {
    getMessage: () => "Unknown order type change.",
    requireTableSelection: false,
  };

  return {
    message: scenario.getMessage(options),
    requireTableSelection: scenario.requireTableSelection,
  };
}
// Get order status by id
export function getOrderStatusById(value) {
  return ORDER_STATUS_VALUES.find((status) => status.value === value) || null;
}

// Get order status label
export function getOrderStatusLabel(value) {
  const status = ORDER_STATUS_VALUES.find((status) => status.id === value);
  return status ? status.label : "";
}
